import { ButtonRoot } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { IconAdvanced } from '@/components/icons/IconAdvanced'
import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import styles from './HeaderButtonClipboard.module.scss'

export const HeaderButtonClipboard = () => {
  const dispatch = useReduxDispatch()
  const clipboardStatus = useReduxSelector((s) => s.view.clipboardStatus)
  const isOpenMobile = useReduxSelector((s) => s.view.mobileStatus === 'clipboard')
  const { isDesktop, loading } = useBreakpoints()

  const onClick = () => {
    if (loading) return
    if (isDesktop) dispatch(viewActions.toggleClipboard())
    else dispatch(viewActions.toggleMobileStatus('clipboard'))
  }

  const onMouseEnter = () => {
    dispatch(viewActions.preloadClipboard())
  }

  return (
    <ButtonRoot
      aria-label='Toggle Clipboard'
      className={cn(styles.container, {
        clipboardStatus,
        isOpenMobile,
        styles,
      })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      {...getClickawayIgnoreProps(['collapse-expanded'])}
    >
      <IconAdvanced.Clipboard countBounce={clipboardStatus === 'collapsed'} />
      <span className={styles.closeIcon}>
        <Icon name='xMark' />
      </span>
    </ButtonRoot>
  )
}
